// Пробное занятие: фиксированная длительность для преподавателей с trial_enabled
export const TRIAL_LESSON_PRICE = 0
export const TRIAL_LESSON_DURATION = 25

// Триал доступен ученику только когда он включён у преподавателя (trial_enabled)
// и у ученика осталась попытка (trial_available)
export const isTrialAvailable = (teacher) => !!teacher?.trial_enabled && !!teacher?.trial_available

export const formatTrialPrice = () => 'Бесплатно'
